import Translation from "@Translation/components/Translation";
import Row from "@Containers/components/Row";
import IconPen from "@Icons/edit/IconPen";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {Colors} from "@Styles/Colors.style";
import {ReactNode} from "react";

interface ManageTicketExtraProps {
    title: string | ReactNode
    edit?: () => void,
    remove: () => void,
}

/**
 * Used by both Addons and Amenities as a "cta" to edit ticket-extra.
 * (Ticket extra === additional "service")
 */
function EditTicketExtra({title, edit = undefined, remove}: ManageTicketExtraProps) {
    const isMobile = useIsMobile()

    return (
        <div className="manage-ticket-extras__edit">
            <Row center justify className="edit-card">
                <button
                    type="button"
                    onClick={edit ?? (() => {})}
                    className={`gb--row ${isMobile ? "gb--row-reverse" : "gb--row-gap"}`}
                >
                    <span className="gb--card-title">
                        {title}
                    </span>
                    {edit && (
                        <Row className="edit-card__edit">
                            <IconPen
                                width="20"
                                height="20"
                                fill={Colors.primaryColor}
                            />
                            {!isMobile && (
                                <Translation
                                    translationKey="sys.edit"
                                />
                            )}
                        </Row>
                    )}
                </button>
                <button
                    type="button"
                    onClick={remove}
                    className="edit-card__remove"
                >
                    <Translation translationKey="sys.remove"/>
                </button>
            </Row>
        </div>
    )
}

export default EditTicketExtra